import React from 'react'

import { useBuyBonusStore, useConfigurationStore, useFreeBuyBonusStore } from '@stores'
import { BSModalButton } from '@components'
import { useTranslation } from '@amusnet/translations/react'
import {
    BonusSystemState,
    BuyBonusFeature,
    BuyBonusRejectedMessage,
    FreespinBonusEndModalButtonClickedMessage,
    GameUIMessageType,
} from 'game-ui-types'

const FBBEndButtons: React.FC = () => {
    const { t } = useTranslation()
    const buyBonusConfig = useConfigurationStore((state) => state.buyBonusConfig)

    const selectedFeature = useBuyBonusStore((state) => state.selectedFeature)
    const setMultiChoiceToggle = useBuyBonusStore((state) => state.setMultiChoiceToggle)
    const setIsForceGuaranteedWinEnabled = useBuyBonusStore((state) => state.setIsForceGuaranteedWinEnabled)
    const updateCurrentFeatureMultiplier = useBuyBonusStore((state) => state.updateCurrentFeatureMultiplier)
    const setIsGuaranteedWinEnabled = useBuyBonusStore((state) => state.setIsGuaranteedWinEnabled)
    const setSelectedFeature = useBuyBonusStore((state) => state.setSelectedFeature)
    const setSelectedFeatureIndex = useBuyBonusStore((state) => state.setSelectedFeatureIndex)

    const setBonusSystemState = useFreeBuyBonusStore((state) => state.setBonusSystemState)
    const activeBonus = useFreeBuyBonusStore((state) => state.activeBonus)
    const setHasActivatedBonus = useFreeBuyBonusStore((state) => state.setHasActivatedBonus)
    const setTotalWin = useFreeBuyBonusStore((state) => state.setTotalWin)
    const hasActiveBonusesLeft = useFreeBuyBonusStore((state) => state.hasActiveBonusesLeft)

    const handleButtonClick = () => {
        setTotalWin('0')

        const buyBonusRejectedMessage: BuyBonusRejectedMessage = {
            type: GameUIMessageType.BUY_BONUS_REJECTED,
        }

        window.uiBus.postMessage(buyBonusRejectedMessage)

        const bonusEndModalButtonClickedMessage: FreespinBonusEndModalButtonClickedMessage = {
            type: GameUIMessageType.FREESPIN_BONUS_END_MODAL_BUTTON_CLICKED, // rename to a more generic message
        }

        window.uiBus.postMessage(bonusEndModalButtonClickedMessage)

        setBonusSystemState(hasActiveBonusesLeft ? BonusSystemState.IN_PLAY : BonusSystemState.INACTIVE)

        if (!hasActiveBonusesLeft) {
            updateCurrentFeatureMultiplier(1)
            setMultiChoiceToggle(false)
            setIsForceGuaranteedWinEnabled(selectedFeature?.guaranteedName === undefined)
            setIsGuaranteedWinEnabled(selectedFeature?.guaranteedName !== undefined)
        } else {
            const freeBuyBonusConfig = activeBonus?.typeConfiguration?.freeBuyBonusConfiguration

            const matchesActiveBonus = (feature: BuyBonusFeature) =>
                feature.name === freeBuyBonusConfig?.featureId ||
                (freeBuyBonusConfig?.guaranteedName && feature.guaranteedName === freeBuyBonusConfig?.guaranteedName)

            const selectedFeatureIndex = buyBonusConfig.features.findIndex(matchesActiveBonus)
            const currentFeature = selectedFeatureIndex !== -1 ? buyBonusConfig.features[selectedFeatureIndex] : null

            setHasActivatedBonus(true)
            setSelectedFeatureIndex(selectedFeatureIndex)
            setSelectedFeature(currentFeature)
            updateCurrentFeatureMultiplier(
                buyBonusConfig.shouldTheFeatureStayActive ? (currentFeature?.multiplier ?? 1) : 1
            )
        }
    }

    return (
        <div className="flex flex-col items-center w-full py-[10px]">
            <BSModalButton id="freespin-bonus-ok" text={t('gameui.ok')} onClick={handleButtonClick} />
        </div>
    )
}

export default FBBEndButtons
